// 引入 vue
import Vue from 'vue'
// 引入路由
import Router from 'vue-router'
// 登录页面
import login from 'views/login/login'
// 创建服务器
import createServer from 'views/createServer/createServer'
// 私服管理
import serverManage from 'views/serverManage/serverManage'
// 个人主页主页面
import home from 'views/home/home'
// 开发者协议
import developerAgreement from 'views/developerAgreement/developerAgreement'
// 开发者信息
import developerInfo from 'views/developerInfo/developerInfo'
// 开发者申请成功
import developerSuccess from 'views/developerSuccess/developerSuccess'
// 开发者申请状态
import developerStatus from 'views/developerStatus/developerStatus'
// 下载开发插件
import downloadPlugin from 'views/downloadPlugin/downloadPlugin'
// 开发文档
import developmentFile from 'views/developmentFile/developmentFile'
// 我的地图mod
import mapMod from 'views/mapMod/mapMod'
// 我的私服mod
import selfMod from 'views/selfMod/selfMod'
// 开发区地图审核
import devMapinspect from 'views/devMapinspect/devMapinspect'
// 测试区地图审核
import testMapinspect from 'views/testMapinspect/testMapinspect'
// 正式区地图审核
import pubMapinspect from 'views/pubMapinspect/pubMapinspect'
// 审核失败
import examineFail from 'views/examineFail/examineFail'
// 地图审核中
import toExamine from 'views/toExamine/toExamine'
// 地图信息不完善提示
import mapInfoImperfect from 'views/mapInfoImperfect/mapInfoImperfect'
// 地图查看
import mapShowStatus from 'views/mapShowStatus/mapShowStatus'
// 游戏内评论
import comment from 'views/comment/comment'
// faq
import faq from 'views/faq/faq'
// 新手教程
import faqNew from 'views/faqNew/faqNew'
// 插件 faq
import pluginFaq from 'views/pluginFaq/pluginFaq'
// 后台 faq
import backstage from 'views/backstage/backstage'
// 收入 faq
import income from 'views/income/income'
// pdf 预览页面
import pdf from 'views/pdf/pdf'
// root 相关文档页面
import rootDoc from 'views/rootDoc/rootDoc'
// 语言切换
import language from 'views/language/language'

// 注册路由
Vue.use(Router)

export default new Router({
  // 使用 / 方式切换路径，默认使用哈希 #
  // mode: 'history',
  linkActiveClass: 'active',
  routes: [
    // 根目录
    {
      path: '/',
      redirect: {
        name: 'login'
      },
      component: login
    },
    // 登录页
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // 个人主页主路由
    {
      path: '/home',
      name: 'home',
      component: home,
      redirect: '/home/mapMod',
      children: [
        // 我的地图MOD
        {
          path: 'mapMod',
          name: 'mapMod',
          component: mapMod
        },
        // 我的私服MOD
        {
          path: 'selfMod',
          name: 'selfMod',
          component: selfMod
        }
      ]
    },
    // 创建服务器
    {
      path: '/createServer',
      name: 'createServer',
      component: createServer
    },
    // 游戏管理
    {
      path: '/serverManage',
      name: 'serverManage',
      component: serverManage
    },
    // 开发者申请协议页面
    {
      path: '/developerAgreement',
      name: 'developerAgreement',
      component: developerAgreement
    },
    // 开发者申请信息页面
    {
      path: '/developerInfo',
      name: 'developerInfo',
      component: developerInfo
    },
    // 开发者申请成功页面
    {
      path: '/developerSuccess',
      name: 'developerSuccess',
      component: developerSuccess
    },
    // 开发者申请状态
    {
      path: '/developerStatus',
      name: 'developerStatus',
      component: developerStatus
    },
    // 下载开发插件
    {
      path: '/downloadPlugin',
      name: 'downloadPlugin',
      component: downloadPlugin
    },
    // 下载开发插件
    {
      path: '/developmentFile/:pid',
      name: 'developmentFile',
      component: developmentFile
    },
    // 开发区地图审核
    {
      path: '/devMapinspect/:mapId/:stage',
      name: 'devMapinspect',
      component: devMapinspect
    },
    // 测试地图审核
    {
      path: '/testMapinspect/:mapId/:stage',
      name: 'testMapinspect',
      component: testMapinspect
    },
    // 正式区地图审核
    {
      path: '/pubMapinspect/:mapId/:stage',
      name: 'pubMapinspect',
      component: pubMapinspect
    },
    // 地图审核失败
    {
      path: '/examineFail/:mapId/:stage',
      name: 'examineFail',
      component: examineFail
    },
    // 审核中
    {
      path: '/toExamine/:mapId/:stage',
      name: 'toExamine',
      component: toExamine
    },
    // 地图信息不完善提示
    {
      path: '/mapInfoImperfect/:mapId/:stage',
      name: 'mapInfoImperfect',
      component: mapInfoImperfect
    },
    // 地图信息查看
    {
      path: '/mapShowStatus/:mapId/:stage',
      name: 'mapShowStatus',
      component: mapShowStatus
    },
    // 游戏内评论
    {
      path: '/comment/:accountId/:mapId/:passKey',
      name: 'comment',
      component: comment
    },
    // faq
    {
      path: '/faq',
      name: 'faq',
      component: faq,
      redirect: '/faq/faqNew',
      children: [
        // 新手教程
        {
          path: 'faqNew',
          name: 'faqNew',
          component: faqNew
        },
        // 插件 faq
        {
          path: 'pluginFaq',
          name: 'pluginFaq',
          component: pluginFaq
        },
        // 后台 faq
        {
          path: 'backstage',
          name: 'backstage',
          component: backstage
        },
        // 后台 faq
        {
          path: 'income',
          name: 'income',
          component: income
        }
      ]
    },
    // pdf 预览页面
    {
      path: '/pdf/:name/:pid',
      name: 'pdf',
      component: pdf
    },
    // rootDoc
    {
      path: '/rootDoc',
      name: 'rootDoc',
      component: rootDoc
    },
    // 语言切换
    {
      path: '/language',
      name: 'language',
      component: language
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js